import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Link from 'next/link';
import dates from '@/utils/date';
import ClientOnly from '@/components/ClientOnly';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const DirectoryList = _ref => {
  let {
    elementId,
    children
  } = _ref;
  return /*#__PURE__*/_jsx("section", _objectSpread(_objectSpread({
    className: styles.container
  }, elementId && {
    id: elementId
  }), {}, {
    children: /*#__PURE__*/_jsx("ul", {
      className: styles.list,
      children: children
    })
  }));
};

const DirectoryItem = _ref2 => {
  let {
    timestamp,
    heading,
    description,
    url,
    featuredImageUrl,
    featuredImageAlt
  } = _ref2;
  return /*#__PURE__*/_jsx("li", {
    className: styles.item,
    children: /*#__PURE__*/_jsx(Link, {
      legacyBehavior: true,
      href: url,
      children: /*#__PURE__*/_jsxs("a", {
        className: styles.item__link,
        children: [featuredImageUrl && /*#__PURE__*/_jsx("div", {
          className: styles.featuredImage,
          children: /*#__PURE__*/_jsx(FeaturedImage, {
            src: featuredImageUrl,
            alt: featuredImageAlt || ''
          })
        }), /*#__PURE__*/_jsx(ClientOnly, {
          children: /*#__PURE__*/_jsx("time", {
            className: styles.time,
            dateTime: dates.toDateString(timestamp),
            children: dates.toFullTextDate(timestamp)
          })
        }), /*#__PURE__*/_jsx("h3", {
          className: styles.heading,
          children: heading
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: description
        })]
      })
    })
  });
};

const FeaturedImage = _ref3 => {
  let {
    src,
    alt
  } = _ref3;
  return /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({
    src: src
  }, alt && {
    alt
  }), {}, {
    loading: "lazy",
    width: 768,
    height: 768
  }));
};

export default DirectoryList;
export { DirectoryItem };